module.exports = __webpack_public_path__ + "static/media/password-on.f5ff6dce.svg";